import '../css/app.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router.js';
import tooltip from './lib/tooltip.js';

const app = createApp(App);
app.use(createPinia());
app.use(router);

// v-tooltip statt title="…": das native Attribut erscheint erst nach
// rund einer Sekunde, lässt sich nicht gestalten und ist auf dem Tablet
// gar nicht erreichbar.
app.directive('tooltip', tooltip);

app.mount('#app');
